import React from "react";
import { Switch, Tooltip } from "@mui/material";
import { hasDevSiteUrl, isDevSite, setDevSite } from "../utils/devSites";

/**
 * Toggles whether a site is treated as a development site. Sites detected from
 * their URL start on, but can still be turned off explicitly.
 */
const devSiteTooltip = (installation, checked) => {
  const autoDetected = hasDevSiteUrl(installation);
  if (checked) {
    return autoDetected
      ? "Auto-detected from the site URL"
      : "Manually marked as a development site";
  }
  return autoDetected
    ? "Auto-detection overridden — counted as a normal site"
    : "Mark this site as a development site";
};

const DevSiteSwitch = ({ installation, checked, onToggle }) => (
  <Tooltip title={devSiteTooltip(installation, checked)}>
    <Switch
      size="small"
      checked={checked}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        setDevSite(installation, e.target.checked);
        if (onToggle) onToggle(e.target.checked);
      }}
      inputProps={{ "aria-label": "Development site" }}
    />
  </Tooltip>
);

/**
 * Shared "Dev Site" column for the MaterialReactTable listings. Rows are
 * expected to carry `is_dev_site` and the original API item as `raw`.
 */
export const devSiteColumn = {
  accessorFn: (row) => (row.is_dev_site ? "Yes" : "No"),
  id: "is_dev_site",
  header: "Dev Site",
  size: 110,
  Cell: ({ row }) => (
    <DevSiteSwitch
      installation={row.original.raw}
      checked={row.original.is_dev_site}
    />
  ),
};

export const devSiteRowProps = (row) => ({
  className: row.original.is_dev_site ? "dev-site-row" : "",
});

export { isDevSite };
export default DevSiteSwitch;
